module.exports = __webpack_public_path__ + "img/20180120_7.adda0b4f.jpeg";